import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import { mapActions, mapGetters, mapState } from 'vuex'
import { TranslateResult } from 'vue-i18n'
import { BCard, BFormRow, BCol, BFormGroup, BRow, BBadge } from 'bootstrap-vue'
import { NumberMixin, PageHeader, Tabs, Tab, AppMessages } from '@kwixeo/interface-vue'
import { FroalaView } from '@kwixeo/form-vue'
import { CustomFieldsDisplay, CustomFieldsDisplayTab } from '@kwixeo/custom-fields-vue'
import CustomPricesView from '../CustomPricesView/CustomPricesView.vue'
import ProductVariations from '../ProductVariations/ProductVariations.vue'
import CatalogPictures from '../CatalogPictures/CatalogPictures.vue'
import ProductDelete from '../ProductDelete/ProductDelete.vue'
import MovementList from '../MovementList/MovementList.vue'
import ElementSalesList from '../ElementSalesList/ElementSalesList.vue'
import MovementListClass from '../MovementList/MovementList'
import Statistics from '../Statistics/Statistics.vue'
import LotList from '../LotList/LotList.vue'
import StockByLocations from '../StockByLocations/StockByLocations.vue'
@Component({
  computed: {
    ...mapGetters('user', ['currency', 'can', 'team']),
    ...mapGetters('subscriptions', ['hasModule']),
    ...mapState('catalog', ['stockLocations'])
  },
  methods: {
    ...mapActions('dynamicModals', ['openModal']),
    ...mapActions('catalog', ['loadStockLocations'])
  },
  components: {
    PageHeader, Tabs, Tab, AppMessages,
    CustomPricesView,
    ProductVariations,
    MovementList,
    CatalogPictures,
    ProductDelete,
    ElementSalesList,
    Statistics,
    LotList,
    StockByLocations,
    FroalaView,
    CustomFieldsDisplay, CustomFieldsDisplayTab,
    BCard, BFormRow, BCol, BFormGroup, BRow, BBadge
  }
})
export default class ProductItem extends Mixins(NumberMixin) {
  openModal!: (params: string|KwixeoInterface.OpenModalParamObject) => void
  currency!: KwixeoFramework.Currency
  hasModule!: (key: string) => boolean
  can!: (key: string, level: number) => boolean
  team!: KwixeoFramework.Team

  @Prop({ required: true }) value!: KwixeoCatalog.Product

  private toDelete = false
  private totalPictures = 0

  get pageTitle (): string {
    return this.$t('catalog.' + (this.value.is_group ? 'group' : 'product') + '.itemTitle') + ' - ' + this.value.reference
  }

  get nbCustomPrices (): number {
    return (this.value.custom_type_prices ? this.value.custom_type_prices.length : 0) + (this.value.custom_quantity_prices ? this.value.custom_quantity_prices.length : 0)
  }

  get hasVariations (): boolean {
    return this.number(this.value.variations_length) > 0 && this.hasModule('catalog-variations')
  }

  get tracabilityLabel (): TranslateResult|null {
    switch (this.value.stock_tracking_mode) {
      case 1:
        return this.$t('catalog.form.traceabilities.lot')
      case 2:
        return this.$t('catalog.form.traceabilities.serial')
      default:
        return null
    }
  }

  get headerButtons (): KwixeoInterface.PageHeaderItems {
    const buttons: KwixeoInterface.PageHeaderItems = []

    if (this.can('catalog-products', 3)) {
      buttons.push({
        label: 'Modifier',
        click: () => {
          this.openModal({
            key: 'catalog-' + (this.value.is_group ? 'group' : 'product') + '-form',
            value: this.value,
            submitted: response => this.$emit('input', response.data)
          })
        }
      })
    }

    if (this.can('catalog-products', 4)) {
      buttons.push({
        label: 'Supprimer',
        click: () => {
          this.toDelete = true
        }
      })
    }

    return buttons
  }

  @Watch('value', { deep: true })
  private watchValue (): void {
    const table: MovementListClass|undefined = this.$refs.movements as MovementListClass
    if (table) {
      table.refresh()
    }
  }

  private updateDefaultPicture (id: number): void {
    const product = JSON.parse(JSON.stringify(this.value))
    product.default_picture_id = id
    this.$emit('input', product)
  }
}
